import React, { useMemo, useState } from "react";
import logo_close from "../assets/close-check.png";
import logo_nophoto from "../assets/nophoto.png";
import Reserve from '../components/Reserve';
import "../styles/ObjectViewer.css";

const formatPrice = (price, currency) => {
  if (price === undefined || price === null || price === ""|| price === "0.00") return "-";
  const value = Number(price);
  if (Number.isNaN(value)) return null;

  const currencyCode =
    typeof currency === "string" && /^[a-z]{3}$/i.test(currency.trim())
      ? currency.trim().toUpperCase()
      : "EUR";

  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "symbol",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (_) {
    return `${value.toFixed(2)} ${currencyCode}`;
  }
};

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

function ObjectViewer({ p_key, object, onClose, listName = "Liste" , p_setLightboxImg, p_isProprio, p_onReserved, p_onEdit }) {
  const [imageError, setImageError] = useState(false);
  const cover = imageError ? logo_nophoto : object?.imagelink || logo_nophoto;

  const infoRows = useMemo(() => {
    if (!object) return [];
    const rows = [
      { label: "Prix", value: formatPrice(object.price, object.currency) },
      { label: "Boutique", value: object.site },
    ];
    return rows.filter((row) => Boolean(row.value));
  }, [object]);

  if (!object) return null;

  const priceDisplay = formatPrice(object.price, object.currency);
  const isReserved = Boolean(object.reservationid);
  const productLink = object.affiliateLink || object.url || object.urllink;
  const storeName = object.site || object.storeName;

  return (
    <div className="objectviewer-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="objectviewer-card" onClick={(e) => e.stopPropagation()}>
        <button className="objectviewer-close" onClick={onClose} aria-label="Fermer">
          <img src={logo_close} alt="Fermer" style={{ width: '100%', height: '100%' }} />
        </button>
        <div className="objectviewer-content">
          <div className="objectviewer-media">
            <img
              src={cover}
              alt={object.title || "Aperçu"}
              loading="lazy"
              onError={() => setImageError(true)}
              onClick={() => p_setLightboxImg(object?.imagelink)}
            />
          </div>
          <div className="objectviewer-body">
            <p className="objectviewer-list">{listName || "Sans nom"}</p>
            {storeName && (
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontSize: 11, fontWeight: 700, background: '#EFF6FF', color: '#2563EB', padding: '2px 10px', borderRadius: 100 }}>{storeName}</span>
              </div>
            )}
            <h3 className="objectviewer-title">{object.title || "Sans titre"}</h3>
            {priceDisplay && priceDisplay !== '-' && (
              <div className="objectviewer-price">{priceDisplay}</div>
            )}
            <div>
              {isReserved ? (
                <span className="objectviewer-status-badge objectviewer-status-reserved">
                  <span className="objectviewer-status-dot" />
                  Réservé
                </span>
              ) : (
                <span className="objectviewer-status-badge objectviewer-status-available">
                  <span className="objectviewer-status-dot" />
                  Disponible
                </span>
              )}
            </div>
            {object.description && (
              <p className="objectviewer-description">{object.description}</p>
            )}
            {productLink && (
              <a
                href={productLink}
                target="_blank"
                rel="noopener noreferrer"
                className="objectviewer-link-btn"
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/></svg>
                Voir le produit
              </a>
            )}
            {p_isProprio && p_onEdit && (
              <button
                className="objectviewer-link-btn"
                onClick={p_onEdit}
                style={{ background: 'white', borderColor: '#DBEAFE', color: '#2563EB', cursor: 'pointer' }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Modifier
              </button>
            )}
            {!isReserved && (
              <Reserve
                p_object={object}
                p_key={p_key}
                p_isProprio={p_isProprio}
                p_btnLabel="🎁 Je réserve ce cadeau"
                p_btnClassName="objectviewer-primary"
                p_onReserved={(reservationId) => {
                  if (typeof p_onReserved === "function") {
                    p_onReserved(object.id, reservationId);
                  }
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ObjectViewer);
